"use client"

import Link from "next/link"

import { useLocale } from "@/lib/locale-context"
import { siteConfig } from "@/lib/site-config"
import { LanguageSwitcher } from "./language-switcher"
import { ThemeToggle } from "./theme-toggle"

const navIds = ["proof", "focus", "projects", "journey", "skills", "contact"] as const

export function SiteFooter() {
  const { t, href } = useLocale()
  const year = new Date().getFullYear()

  return (
    <footer className="border-t-2 border-foreground">
      <div className="shell grid12 py-10 md:py-12">
        <div className="col-span-12 md:col-span-4">
          <p className="t-small font-semibold uppercase tracking-[0.06em] text-foreground">
            {siteConfig.name}
          </p>
          <p className="t-small mt-3 max-w-[34ch] text-muted-foreground">{t.footer.statement}</p>
        </div>

        <nav className="col-span-6 mt-8 md:col-span-3 md:col-start-6 md:mt-0" aria-label={t.nav.home}>
          <ul className="flex flex-col gap-2.5 md:gap-1.5">
            {navIds.map((id) => (
              <li key={id}>
                <a
                  href={`${href("/")}#${id}`}
                  className="t-small text-muted-foreground transition-colors hover:text-accent"
                >
                  {id === "skills" ? t.alt.skills : t.nav[id]}
                </a>
              </li>
            ))}
            <li>
              <Link
                href="/cv"
                className="t-small text-muted-foreground transition-colors hover:text-accent"
              >
                {t.nav.cv}
              </Link>
            </li>
          </ul>
        </nav>

        <div className="col-span-6 mt-8 md:col-span-3 md:col-start-10 md:mt-0">
          <ul className="flex flex-col gap-2.5 md:gap-1.5">
            {[
              { label: "LinkedIn", href: siteConfig.social.linkedin },
              { label: "GitHub", href: siteConfig.social.github },
              { label: "Docker Hub", href: siteConfig.social.docker },
            ].map((item) => (
              <li key={item.label}>
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="t-small text-muted-foreground transition-colors hover:text-accent"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="mt-5 flex items-center gap-4">
            <LanguageSwitcher />
            <ThemeToggle />
          </div>
        </div>

        <p className="t-small col-span-12 mt-10 border-t border-border pt-5 text-muted-foreground md:mt-12">
          {`© ${year} ${siteConfig.name}. ${t.footer.rights}`}
        </p>
      </div>
    </footer>
  )
}
